import * as React from 'react';
import { Button } from '@mui/material';
import { useFilterList } from '../../../../context/FilterListProvider';
import { selectRule } from './common';
import type { IData } from '../../../../types';

interface NewRuleButtonProps {
    callback: (id: number | string, rule?: IData) => void;
}

export const NewRuleButton = ({ callback }: NewRuleButtonProps) => {
    const [filterList] = useFilterList();

    const onNewRule = () => {
        let rule = selectRule(-1, -1, filterList);
        callback(-1, rule);
    };

    return (
        <Button size="small" onClick={onNewRule}>New Rule</Button>
    );
};

export default NewRuleButton;
